// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const aboutUsData = createApi({
  reducerPath: "aboutUsApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getAboutUs: builder.query({
      query: () => `about_us`,
      transformResponse: (response, meta, arg) => response.data,
    }),
    getOurCEO: builder.query({
      query: () => `our_ceo`,
      transformResponse: (response, meta, arg) => response.data,
    }),
    getLeadershipTeam: builder.query({
      query: () => `leadership_team`,
      transformResponse: (response, meta, arg) => response.data,
    }),
    getWhyEdnovate: builder.query({
      query: () => `why_ednovate`,
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAboutUsQuery,
  useGetOurCEOQuery,
  useGetLeadershipTeamQuery,
  useGetWhyEdnovateQuery,
} = aboutUsData;
